import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Descarga y Lee',
    desc: 'Descarga el protocolo y lee las 7 claves (te tomará 15 minutos).'
  }, {
    num: '2',
    title: 'Aplica el Itinerario',
    desc: 'Sigue el itinerario nocturno desde tu última comida del día.'
  }, {
    num: '3',
    title: 'Despierta Renovada',
    desc: 'Despierta 16 horas después sintiéndote ligera, fresca y con claridad mental.'
  }];
  return <section className="py-20 md:py-32 px-4 bg-white" data-id="element-98">
      <div className="max-w-5xl mx-auto" data-id="element-99">
        <FadeIn data-id="element-100">
          <div className="text-center mb-16" data-id="element-101">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-102">
              Cómo funciona
            </h2>
            <p className="text-lg text-brand-dark/70" data-id="element-103">
              Un proceso simple, diseñado para mujeres ocupadas.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-104">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-105">
              <div className="flex flex-col items-center text-center relative" data-id="element-106">
                {/* Connecting line for desktop */}
                {index !== steps.length - 1 && <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-[2px] bg-brand-lavenderLight border-t-2 border-dashed border-brand-lavender/30" data-id="element-107" />}

                <div className="w-20 h-20 rounded-full bg-brand-lavenderLight flex items-center justify-center text-3xl font-serif font-bold text-brand-lavender mb-6 relative z-10 shadow-sm border-4 border-white" data-id="element-108">
                  {step.num}
                </div>
                <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-109">
                  {step.title}
                </h3>
                <p className="text-brand-dark/70 leading-relaxed" data-id="element-110">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        {/* Proof / Believability Block */}
        <FadeIn delay={0.3} data-id="element-111">
          <div className="bg-brand-sageLight/50 rounded-3xl p-8 md:p-12 text-center max-w-4xl mx-auto border border-brand-sage/20" data-id="element-112">
            <h3 className="text-2xl md:text-3xl font-bold text-brand-dark mb-6 font-serif italic" data-id="element-113">
              ¿Qué cambia en 7 días?
            </h3>
            <p className="text-lg md:text-xl text-brand-dark/80 leading-relaxed" data-id="element-114">
              En menos de una semana, la mayoría de las mujeres reportan una{' '}
              <strong className="text-brand-sage font-semibold" data-id="element-115">
                reducción del 70% en la intensidad de los sofocos nocturnos
              </strong>{' '}
              y una disminución visible de la hinchazón abdominal al despertar,
              simplemente por cambiar el orden y la temperatura de su rutina
              nocturna.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}